





































































































































































































































































































import Vue from 'vue'
import SharedRoom from '@/components/map/SharedRoom.vue'
import Room from '@/components/map/Room.vue'
import EastWingRightColumn from '@/components/map/static-maps/louis-brier/subcomponents/EastWingRightColumn.vue'
export default Vue.extend({
  components: { EastWingRightColumn, SharedRoom, Room },
  props: {
    patients: {
      type: Array,
      required: true,
    },
    patientsByRoomNumber: {
      type: Object,
      required: true,
    },
    sharedRooms: {
      type: Object,
      required: true,
    },
    searchQuery: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      verticalRoomHeight: 60,
      verticalRoomWidth: 45,
    }
  },
  computed: {
    cssVars() {
      return {
        '--vertical-room-width': this.verticalRoomWidth + 'px',
      }
    },
  },
})
